import React from "react";
import { ArcStack } from "@src/core/ui";
import ToggleCollapseView from "@src/features/zones/components/toggle-collapse-view";
import { ZoneList } from '@src/features/zones/pages/zones-page/components/ZoneList';
import { ZoneEntity, ZoneType } from "@src/core/features";

interface TemporarySectionsProps {
    zones: ZoneEntity[];
}

export const TemporarySections: React.FC<TemporarySectionsProps> = (props) => {
  const { zones } = props;
  return (
    <ArcStack >   
      <ArcStack marginTop={"16px"}> 
        <ToggleCollapseView 
          count={zones.length}
          zoneType={ZoneType.TEMPORARY}>
          <ZoneList zones={zones} />    
        </ToggleCollapseView>
      </ArcStack>
    </ArcStack>
  );
};